document.addEventListener('DOMContentLoaded', function () {

    var customerType = document.body.getAttribute('data-customerType');
    console.log("customerType",customerType)
    
    // Start - For quick view on collection page
      const quickviewTriggers = document.querySelectorAll('.product-listing__quickview-trigger');
      quickviewTriggers.forEach(function(trigger) {
        
          trigger.addEventListener('click', function() {
              console.log('QV click');
            
            setTimeout(() => {
             let productHandle = document.body.getAttribute('data-productHandle');
             console.log("productHandle",productHandle)
             
              const variantSelection = document.createElement('div');
              variantSelection.className = 'variant-selection-container';
              const productVariants = document.querySelector('.product-quickview__container .product__variants-swatches');
              
              if (productVariants) {
                  productVariants.parentNode.insertBefore(variantSelection, productVariants);
              }
             fetchProductVariants(productHandle);
          }, 800);
             
          });
      });
     // End - For quick view on collection page
    
      const storeUrl = 'https://amarteskincare.com';
      const storefrontAccessToken = '0ffb4df6d98b326c0d428b27d3edf90d';
    
      // Function to fetch product variants
      async function fetchProductVariants(productHandle) {
          const query = `
          {
            productByHandle(handle: "${productHandle}") {
              title
              variants(first: 100) {
                edges {
                  node {
                    id
                    title
                    availableForSale
                    selectedOptions {
                      name
                      value
                    }
                    metafield(namespace: "custom", key: "variant_for_b2b_b2c_both_") {
                      value
                    }
                    image {
                      src
                    }
                  }
                }
              }
            }
          }`;
  
          try {
              const response = await fetch(`${storeUrl}/api/2024-01/graphql.json`, {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                      'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                  },
                  body: JSON.stringify({ query }),
              });
  
              const data = await response.json();
            console.log("data",data)
             
              const arrayVariants = data.data.productByHandle.variants.edges;
              console.log("arrayVariants",arrayVariants)
           
              let filteredVariants;
              if (customerType == "wholesale") { 
                  filteredVariants = arrayVariants.filter(variant => variant.node.metafield && (variant.node.metafield.value === 'B2B' || variant.node.metafield.value === 'Both'));
              } else { 
                  //filteredVariants = arrayVariants.filter(variant => variant.node.metafield && (variant.node.metafield.value === 'Both' ));
                  filteredVariants = arrayVariants.filter(variant => !variant.node.metafield || variant.node.metafield.value === "Both" );
              }
            console.log("filteredVariants",filteredVariants);
            console.log("filteredVariants length",filteredVariants.length);
            if(filteredVariants.length >= 1){
              renderVariantOptions(filteredVariants);
            }
          } catch (error) {
              console.error('Error fetching variants:', error);
          }
      }
  
      // Render variant options dynamically
      function renderVariantOptions(filteredVariants) {

          const optionNames = filteredVariants[0].node.selectedOptions.map(opt => opt.name); // Get option names dynamically
          console.log("optionNames",optionNames)
        
           // Create HTML structure dynamically based on optionNames length
      let optionsHTML = '';
  
      // Create for the first option (Color)
      if (optionNames.length >= 1) {
          optionsHTML += `
          <div class="option-1-selecter">
              <p class="heading ${optionNames[0].toLowerCase().replace(/\s+/g, '-')}-name">${optionNames[0]}: <span class="option1-value selected-value"></span></p>
              <div id="color-options" class="${optionNames[0].toLowerCase().replace(/\s+/g, '-')}-options"></div>
          </div>`;
      }
  
      // Create for the second option (Size)
      if (optionNames.length >= 2 ) {
          optionsHTML += `
          <div class="option-2-selecter">
              <p class="heading ${optionNames[1].toLowerCase().replace(/\s+/g, '-')}-name">${optionNames[1]}: <span class="option2-value selected-value"></span></p>
              <div id="size-options" class="${optionNames[1].toLowerCase()}"></div>
          </div>`;
      }
  
      // Create for the third option (Material) if it exists
      if (optionNames.length === 3) {
          optionsHTML += `
          <div class="option-3-selecter">
              <p class="heading ${optionNames[2].toLowerCase().replace(/\s+/g, '-')}-name">${optionNames[2]}: <span class="option3-value selected-value"></span></p>
              <div id="material-options" class="${optionNames[1].toLowerCase().replace(/\s+/g, '-')}"></div>
          </div>`;
      }
        //console.log("optionsHTML",optionsHTML)
    
        let variantContainer = document.querySelector('.variant-selection-container');
      
        
        variantContainer.insertAdjacentHTML('beforeend', optionsHTML);
        console.log("optionNames.length",optionNames.length)
       
       
         if (optionNames.length >= 1) {
          var colorContainer = variantContainer.querySelector('#color-options');
           colorContainer.innerHTML = '';
         }
        if (optionNames.length >= 2) {
          var sizeContainer = variantContainer.querySelector('#size-options');
          sizeContainer.innerHTML = '';
        }
        if (optionNames.length == 3) {
          var materialContainer = variantContainer.querySelector('#material-options');
          materialContainer.innerHTML = '';
        }
          // colorContainer.innerHTML = '';
          // sizeContainer.innerHTML = '';
          // materialContainer.innerHTML = '';
  
          // Render color options as radio buttons
          const colors = [...new Set(filteredVariants.flatMap(variant => 
              variant.node.selectedOptions.filter(opt => opt.name === optionNames[0]).map(opt => opt.value)))];
           //console.log("colors",colors)
          colors.forEach((color, index) => {
            const colorVariant = filteredVariants.find(variant => 
              variant.node.selectedOptions.some(opt => opt.name === optionNames[0] && opt.value === color)
            );
            
            // console.log("colorVariant",colorVariant)
             const imageSrc = colorVariant.node.image ? colorVariant.node.image.src : ''; // Get image src for this color
            
              const colorRadio = document.createElement('input');
              colorRadio.type = 'radio';
              colorRadio.name = optionNames[0];
              colorRadio.value = color;
              colorRadio.id = `color-${color}`;
              colorRadio.classList.add('variants-input');
              colorRadio.checked = index === 0; // Check the first color by default

  
            if(optionNames.length == 1 ){ 
               colorRadio.addEventListener('change', () => updateSelectedVariant(filteredVariants));
            }
            if (optionNames.length >= 2 ) {
            //  colorRadio.addEventListener('change', () => updateSizeOptions(color, filteredVariants));
              
              colorRadio.addEventListener('change', () => {
                console.log("color chnage")
                let previouslySelectedSize = null; 
                const optionSizeContainer = document.getElementById('size-options');
                const radioButtons = optionSizeContainer.querySelectorAll('input[name="' + optionNames[1] + '"]');
                console.log("radioButtons", radioButtons);
                radioButtons.forEach(radio => {
                    if (radio.checked) {
                        previouslySelectedSize = radio.value;
                    }
                });
            
                if (!previouslySelectedSize && radioButtons.length > 0) {
                    const firstRadio = radioButtons[0];
                    firstRadio.checked = true; 
                    previouslySelectedSize = firstRadio.value;
                }
            
                console.log("Previously selected size (or defaulted to first):", previouslySelectedSize);
                updateSelectedVariant(filteredVariants)
               });
            

            }
            
            
              const colorLabel = document.createElement('label');
              colorLabel.setAttribute('for', `color-${color}`);
              colorLabel.textContent = color;
  //console.log("color==",color)
               colorLabel.classList.add('swatches__form--label',`${optionNames[0].toLowerCase().replace(/\s+/g, '-')}`);
  
  
            // If the variant is not available for sale, add a class
            if (!colorVariant.node.availableForSale) {
                colorLabel.classList.add('not-available'); 
            }
            
             // Set background image from variant image src
            if (imageSrc && `${optionNames[0]}` == "Color") {
                colorLabel.style.backgroundImage = `url(${imageSrc})`;
                colorLabel.style.backgroundSize = '50px';
                colorLabel.style.backgroundPosition = 'center';
               // colorLabel.style.width = '50px'; 
               // colorLabel.style.height = '50px'; 
                colorLabel.style.display = 'inline-block';
            }
           // console.log("colorRadio",colorRadio)
              colorContainer.appendChild(colorRadio);
              colorContainer.appendChild(colorLabel);
          });
  
          // Select the default color and update sizes based on it
          const defaultColor = colors[0];
         if(optionNames.length == 1){
               updateSelectedVariant(filteredVariants);
            }
        
        if (optionNames.length == 2 || optionNames.length == 3) {
          updateSizeOptions(defaultColor, filteredVariants);
          
        }
        
      }
  
      function updateSizeOptions(selectedColor, filteredVariants) {
        
          const sizeContainer = document.getElementById('size-options');
          sizeContainer.innerHTML = '';
  
          const optionNames = filteredVariants[0].node.selectedOptions.map(opt => opt.name); // Get option names dynamically
          //console.log("optionNames",optionNames.length)
        
          // Get sizes based on selected color
          const sizes = [...new Set(
              filteredVariants
                  .filter(variant =>
                      variant.node.selectedOptions.some(opt => opt.name === optionNames[0] && opt.value === selectedColor)
                  )
                  .map(variant => variant.node.selectedOptions.find(opt => opt.name === optionNames[1]).value)
          )];



          // Render size options as radio buttons
          sizes.forEach((size, index) => {
            
             const sizeVariant = filteredVariants.find(variant =>
              variant.node.selectedOptions.some(opt => opt.name === optionNames[0] && opt.value === selectedColor) &&
              variant.node.selectedOptions.some(opt => opt.name === optionNames[1] && opt.value === size)
          );
           
              const sizeRadio = document.createElement('input');
              sizeRadio.type = 'radio';
              sizeRadio.name = optionNames[1]; // Keep size name
              sizeRadio.value = size;
              sizeRadio.id = `size-${size}`;
              sizeRadio.classList.add('variants-input');
              sizeRadio.checked = index === 0; // Check the first size by default
             

  
            if(optionNames.length >= 2){
               sizeRadio.addEventListener('change', () => updateSelectedVariant(filteredVariants));
            }
            
            if (optionNames.length == 3 ){
              sizeRadio.addEventListener('change', () => updateMaterialOptions(selectedColor, size, filteredVariants));
            }
            
              const sizeLabel = document.createElement('label');
              sizeLabel.setAttribute('for', `size-${size}`);
              sizeLabel.textContent = size;
  
             sizeLabel.classList.add('swatches__form--label',`${optionNames[1].toLowerCase().replace(/\s+/g, '-')}`);
  
            // If the variant is not available for sale, add a class
          if (!sizeVariant.node.availableForSale) {
              sizeLabel.classList.add('not-available'); 
          }
            
              sizeContainer.appendChild(sizeRadio);
              sizeContainer.appendChild(sizeLabel);
          });


          
  
          // Select the default size and update materials based on it
          const defaultSize = sizes[0];
  
         if(optionNames.length == 2){
               updateSelectedVariant(filteredVariants);
            }
        
        if (optionNames.length == 3 ){
          updateMaterialOptions(selectedColor, defaultSize, filteredVariants);
        }
        
      }
  
      function updateMaterialOptions(selectedColor, selectedSize, filteredVariants) {
        console.log("in update material")
          const materialContainer = document.getElementById('material-options');
          materialContainer.innerHTML = '';
  
          const optionNames = filteredVariants[0].node.selectedOptions.map(opt => opt.name); // Get option names dynamically
  
          // Get unique materials based on selected color and size
          const materials = [...new Set(
              filteredVariants
                  .filter(variant => 
                      variant.node.selectedOptions.some(opt => opt.name === optionNames[0] && opt.value === selectedColor) &&
                      variant.node.selectedOptions.some(opt => opt.name === optionNames[1] && opt.value === selectedSize)
                  )
                  .map(variant => variant.node.selectedOptions.find(opt => opt.name === optionNames[2]).value)
          )];
  
          // Render material options as radio buttons
          materials.forEach((material, index) => {
              const materialRadio = document.createElement('input');
              materialRadio.type = 'radio';
              materialRadio.name = optionNames[2]; // Keep material name
              materialRadio.value = material;
              materialRadio.id = `material-${material}`;
              materialRadio.classList.add('variants-input');
              materialRadio.checked = index === 0; // Check the first material by default
              materialRadio.addEventListener('change', () => updateSelectedVariant(filteredVariants));
  
              const materialLabel = document.createElement('label');
              materialLabel.setAttribute('for', `material-${material}`);
              materialLabel.textContent = material;
              materialLabel.classList.add('swatches__form--label',`${optionNames[2].toLowerCase().replace(/\s+/g, '-')}`);
  
             // Check if availableForSale is false and add class if needed
  
              const materialVariant = filteredVariants.find(variant =>
                  variant.node.selectedOptions.some(opt => opt.name === optionNames[0] && opt.value === selectedColor) &&
                  variant.node.selectedOptions.some(opt => opt.name === optionNames[1] && opt.value === selectedSize) &&
                  variant.node.selectedOptions.some(opt => opt.name === optionNames[2] && opt.value === material)
              );
  
              if (!materialVariant.node.availableForSale) {
                  materialLabel.classList.add('not-available');
              }
            
              materialContainer.appendChild(materialRadio);
              materialContainer.appendChild(materialLabel);
          });
  
          // Update the variant ID input based on the selected color, size, and material
          updateSelectedVariant(filteredVariants);
      }
  
      function updateSelectedVariant(filteredVariants) {
        
          const optionNames = filteredVariants[0].node.selectedOptions.map(opt => opt.name);
          //console.log("optionNames.length",optionNames.length)
          var variantContainerValues = document.querySelector('.variant-selection-container');
        
        if(optionNames.length >= 1){
            var colorSelected = variantContainerValues.querySelector(`input[name="${filteredVariants[0].node.selectedOptions[0].name}"]:checked`)?.value;
            var selectedColorValue = variantContainerValues.querySelector(".option1-value");
            selectedColorValue.innerHTML = `${colorSelected}`;
            
        }
         if(optionNames.length >= 2){
            var sizeSelected = variantContainerValues.querySelector(`input[name="${filteredVariants[0].node.selectedOptions[1].name}"]:checked`)?.value;
            var selectedSizeValue = variantContainerValues.querySelector(".option2-value");
            selectedSizeValue.innerHTML = `${sizeSelected}`;
         }
        
         if(optionNames.length == 2){
            if (!colorSelected || !sizeSelected ) {
              return;
             }
         }
        if(optionNames.length == 3){ 
            var materialSelected = variantContainerValues.querySelector(`input[name="${filteredVariants[0].node.selectedOptions[2].name}"]:checked`)?.value;
              console.log("materialSelected",materialSelected)                      
            if (!colorSelected || !sizeSelected || !materialSelected) {
                return;
            }
  
          var selectedMaterialValue = variantContainerValues.querySelector(".option3-value");
          selectedMaterialValue.innerHTML = `${materialSelected}`;
          
        }
          console.log("colorSelected",colorSelected)
          console.log("sizeSelected",sizeSelected)
          //console.log("materialSelected",materialSelected)

          // Click on the color swatch
          const colorLabel = document.querySelector(`.product__section--element .variant-label[data-value='${colorSelected}']`);
          if (colorLabel) {
              colorLabel.click();
          }
  
          // Click on the size label
          const sizeLabel = document.querySelector(`.product__section--element .variant-label[data-value='${sizeSelected}']`);
          if (sizeLabel) {
              sizeLabel.click();
          }
  
        if(optionNames.length == 3){ 
          // Click on the material label
          const materialLabel = document.querySelector(`.product__section--element .variant-label[data-value='${materialSelected}']`);
          if (materialLabel) {
              materialLabel.click();
          }
        }
      }
  if (document.body.classList.contains("template-product")) {
    var productInfo = document.getElementsByClassName("product__section-details");
      var productHandle = productInfo[0].getAttribute('data-productHandle');
    
      fetchProductVariants(productHandle);
  }
    
  });
  
  document.addEventListener("DOMContentLoaded", function () {
    // Start - Remove free gift product
    var wholesale = document.body.getAttribute("data-customertype");
    if (wholesale === "wholesale") {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          var removeGiftId = document.getElementById("mini-cart").getAttribute("guest-data-freegift");
          console.log("removeGiftId", removeGiftId);
          var itemExists = cart.items.some(item => item.id == removeGiftId);
  
          if (itemExists) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: new URLSearchParams({
                id: removeGiftId,
                quantity: 0
              })
            })
              .then(response => {
                if (response.ok) {
                  location.reload();
                  console.log('wholesale : Product removed from cart');
                } else {
                  throw new Error('Error removing product from cart');
                }
              })
              .catch(error => {
                console.error('wholesale : Error product removed from cart', error);
              });
          }
        });
    }
    // End - Remove free gift product
  });
  // ====================  shg-product-atc Button Click Start ======================== //
  document.addEventListener("click", function(e) {
    const atcBtn = e.target.closest(".shg-product-atc-btn-wrapper.rca-add-to-cart-submit a");
    if (atcBtn) {
      setTimeout(() => {
        const cartTriggerBtn = document.querySelector(
          ".cart-links__link-cart .js-mini-cart-trigger"
        );
        if (cartTriggerBtn) {
          cartTriggerBtn.click();
        }
      }, 1500);
    }
  });
  // ====================  shg-product-atc Button Click End ======================== //

  